import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconPorositySizeS from './IconPorosity_size_s';

const props: CreateIconArguments = {
  l: IconPorositySizeS,
  m: IconPorositySizeS,
  s: IconPorositySizeS,
  xs: IconPorositySizeS,
  name: 'IconPorosity',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
